import React from "react";

// Fouten en waarschuwingen worden meteen voorgelezen (role="alert", assertive);
// info/success blijven beleefd (role="status", polite).
const URGENT_TYPES = new Set(["error", "warning", "warn"]);

export default function Alert({ type = "info", title, children, className = "", style, ...props }) {
  const classes = ["alert", type].join(" ").trim();
  const urgent = URGENT_TYPES.has(type);
  return (
    <div
      className={`${classes} ${className}`}
      role={urgent ? "alert" : "status"}
      aria-live={urgent ? "assertive" : "polite"}
      style={style}
      {...props}
    >
      {title && <strong className="alert__title">{title}</strong>}
      <div>{children}</div>
    </div>
  );
}
